module.exports = __webpack_public_path__ + "static/media/BannerD7.12785636.png";